(function () {
  var STORAGE_KEY = 'heathen:recently-viewed-handles';
  var LEGACY_KEYS = ['heathen_recently_viewed', 'recentlyViewedProducts', 'heathen_recently_viewed_handles'];

  function sanitizeHandle(value) {
    if (!value) return '';
    return String(value).trim().toLowerCase().replace(/[^a-z0-9\-]/g, '');
  }

  function parseHandles(raw) {
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.map(sanitizeHandle).filter(Boolean);
      if (parsed && Array.isArray(parsed.handles)) return parsed.handles.map(sanitizeHandle).filter(Boolean);
    } catch (e) {}
    return String(raw)
      .split(/[,\s|]+/)
      .map(sanitizeHandle)
      .filter(Boolean);
  }

  function normalizeSize(value) {
    if (value === null || value === undefined) return '-';
    var out = String(value).trim();
    return out || '-';
  }

  function parseEntries(raw) {
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        if (parsed.length && typeof parsed[0] === 'object' && parsed[0] !== null) {
          return parsed
            .map(function (entry) {
              var handle = sanitizeHandle(entry.handle);
              if (!handle) return null;
              return { handle: handle, size: normalizeSize(entry.size) };
            })
            .filter(Boolean);
        }
        return parsed
          .map(sanitizeHandle)
          .filter(Boolean)
          .map(function (handle) {
            return { handle: handle, size: '-' };
          });
      }

      if (parsed && Array.isArray(parsed.handles)) {
        return parsed.handles
          .map(sanitizeHandle)
          .filter(Boolean)
          .map(function (handle) {
            return { handle: handle, size: '-' };
          });
      }
    } catch (e) {}

    return parseHandles(raw).map(function (handle) {
      return { handle: handle, size: '-' };
    });
  }

  function readStoredEntries() {
    var entries = [];
    try {
      entries = parseEntries(localStorage.getItem(STORAGE_KEY));
    } catch (e) {}
    if (entries.length) return entries;
    for (var i = 0; i < LEGACY_KEYS.length; i++) {
      try {
        entries = parseEntries(localStorage.getItem(LEGACY_KEYS[i]));
      } catch (e) {
        entries = [];
      }
      if (entries.length) return entries;
    }
    return [];
  }

  function writeStoredEntries(entries) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(0, 100)));
    } catch (e) {}
  }

  function updateStoredEntrySize(handle, size) {
    if (!handle || !size || size === '-') return;
    var entries = readStoredEntries();
    var changed = false;
    entries = entries.map(function (entry) {
      if (entry && entry.handle === handle && (!entry.size || entry.size === '-')) {
        changed = true;
        return {
          handle: entry.handle,
          size: size
        };
      }
      return entry;
    });
    if (changed) writeStoredEntries(entries);
  }

  function trackCurrentHandle(root) {
    var handle = sanitizeHandle(root.getAttribute('data-current-handle'));
    var size = normalizeSize(root.getAttribute('data-current-size'));
    if (!handle) return;
    var entries = readStoredEntries().filter(function (entry) {
      return entry.handle !== handle;
    });
    entries.unshift({ handle: handle, size: size });
    writeStoredEntries(entries);
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';
    try {
      return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function extractSize(product) {
    if (!product || !product.options || !product.variants || !product.variants.length) return '-';
    var variant = product.variants[0];
    var sizeIndex = -1;
    for (var i = 0; i < product.options.length; i++) {
      var opt = String(product.options[i] || '').toLowerCase();
      if (opt === 'size' || opt === 'rozmiar') {
        sizeIndex = i;
        break;
      }
    }
    if (sizeIndex === -1) return '-';
    var value = variant['option' + (sizeIndex + 1)];
    return value || '-';
  }

  function fetchSizeFromProductPage(handle) {
    return fetch('/products/' + handle, { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        if (!html) return '-';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('.heathen-pdp-size-row .value');
        if (!node) return '-';
        return normalizeSize(node.textContent);
      })
      .catch(function () {
        return '-';
      });
  }

  function buildCard(product, sizeLabel, storedSize) {
    var img = product.featured_image || '';
    var price = product.variants && product.variants[0] ? product.variants[0].price : product.price;
    var size = normalizeSize(storedSize);
    if (size === '-') size = extractSize(product);
    var alt = (product.title || '').replace(/"/g, '&quot;');
    return (
      '<a href="' +
      product.url +
      '" style="width: 100%; display: inline-block;">' +
      '<div class="product-item">' +
      '<div class="product-image">' +
      '<div class="background-overlay-grey" role="presentation" aria-hidden="true"></div>' +
      (img ? '<img src="' + img + '" alt="' + alt + '" class="lazyload" loading="lazy">' : '') +
      '</div>' +
      '<div class="product-brand">' +
      (product.vendor || '-') +
      '</div>' +
      '<div class="product-name" title="' +
      alt +
      '" aria-label="' +
      alt +
      '">' +
      (product.title || '') +
      '</div>' +
      '<div class="product-price"><span class="regular-price" style="color: #232323;">' +
      formatMoney(price) +
      '</span></div>' +
      '<div class="product-size">' +
      sizeLabel +
      ': ' +
      size +
      '</div>' +
      '</div>' +
      '</a>'
    );
  }

  function updateArrows(root, slider) {
    var prev = root.querySelector('[data-recently-prev]');
    var next = root.querySelector('[data-recently-next]');
    if (!prev || !next) return;
    var maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth - 1);
    var atStart = slider.scrollLeft <= 1;
    var atEnd = maxScroll <= 0 || slider.scrollLeft >= maxScroll - 1;
    prev.classList.toggle('slick-disabled', atStart);
    next.classList.toggle('slick-disabled', atEnd);
    prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  }

  function getStep(slider) {
    var first = slider.querySelector('a');
    if (!first) return 360;
    var style = window.getComputedStyle(slider);
    var gap = parseFloat(style.gap || style.columnGap || '4') || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function bindSlider(root, slider) {
    var prev = root.querySelector('[data-recently-prev]');
    var next = root.querySelector('[data-recently-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        slider.scrollBy({ left: -getStep(slider), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        slider.scrollBy({ left: getStep(slider), behavior: 'smooth' });
      });
    }
    slider.addEventListener('scroll', function () {
      updateArrows(root, slider);
    });
    window.addEventListener('resize', function () {
      updateArrows(root, slider);
    });
    updateArrows(root, slider);
  }

  function renderEmpty(root, message) {
    var empty = root.querySelector('[data-recently-empty]');
    var showAll = root.querySelector('[data-recently-show-all]');
    if (empty) {
      empty.textContent = message;
      empty.hidden = false;
    }
    if (showAll) showAll.hidden = true;
  }

  function initRoot(root) {
    var slider = root.querySelector('[data-recently-slider]');
    if (!slider) return;
    trackCurrentHandle(root);

    var currentHandle = sanitizeHandle(root.getAttribute('data-current-handle'));
    var limit = parseInt(root.getAttribute('data-limit') || '12', 10);
    var emptyMessage = root.getAttribute('data-empty-message') || 'Brak ostatnio oglądanych produktów.';
    var sizeLabel = root.getAttribute('data-size-label') || 'Rozmiar';

    var entries = readStoredEntries().filter(function (entry) {
      return entry && entry.handle;
    });
    if (currentHandle) {
      entries = entries.filter(function (entry) {
        return entry.handle !== currentHandle;
      });
    }
    entries = entries.slice(0, Math.max(limit, 1));
    if (!entries.length) {
      renderEmpty(root, emptyMessage);
      return;
    }

    Promise.all(
      entries.map(function (entry) {
        return fetch('/products/' + entry.handle + '.js')
          .then(function (r) {
            if (!r.ok) return null;
            return r.json().then(function (product) {
              var knownSize = normalizeSize(entry.size);
              if (knownSize !== '-') {
                return { product: product, size: knownSize };
              }
              return fetchSizeFromProductPage(entry.handle).then(function (resolvedSize) {
                var finalSize = normalizeSize(resolvedSize);
                if (finalSize !== '-') updateStoredEntrySize(entry.handle, finalSize);
                return { product: product, size: finalSize };
              });
            });
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var valid = products
        .filter(function (item) {
          return item && item.product;
        })
        .slice(0, limit);
      if (!valid.length) {
        renderEmpty(root, emptyMessage);
        return;
      }
      slider.innerHTML = valid
        .map(function (item) {
          return buildCard(item.product, sizeLabel, item.size);
        })
        .join('');
      var showAll = root.querySelector('[data-recently-show-all]');
      var empty = root.querySelector('[data-recently-empty]');
      if (showAll) showAll.hidden = false;
      if (empty) empty.hidden = true;
      bindSlider(root, slider);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-heathen-recently-root]').forEach(initRoot);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-heathen-recently-root]').forEach(initRoot);
  });
})();
